<!-- GROUP -->
<template>
    <tr>
      <td :colspan="this.headers_length">
        <v-data-table :items="[0]" hide-actions hide-headers ref="parts">
          <template #no-data><span></span></template>
  
          <template #items>
            <!-- GROUP TITLE -->
    <tr :key="`group-${group.name}-title`" :style="{ background: skin.primary_color }" class="subPrimary--text">
      <td :colspan="headers_length.length" class="pa-2">
        <strong>{{ group.name }}</strong>
      </td>
    </tr>
     
    <!-- GROUP PARTS -->
    <Parts :headers_length="headers_length" :group_name="group.name" :parts="group.parts" :filter_text="filter_text"
      :key="`group-${group.name}-parts`" :grouped_by="grouped_by" :disable_select_action="disable_select_action" :showSelected="showSelected"/>
  </template>
  </v-data-table>
  </td>
  </tr>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  
  export default {
    props: {
      headers_length: {
        type: Number,
        required: true
      },
      group: {
        type: Object,
        required: true
      },
      showSelected: {
      type: Boolean,
      default: false
    },
      filter_text: {
        type: String,
        required: true
      },
      grouped_by: {
        type: String,
        required: true
      },
      disable_select_action: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      ...mapState({
        skin: state => state.settings.skin
      })
    },
    components: {
      Parts: () => import("./Parts.mobile")
    },
  }
  </script>